import MuiIconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const StyledIconButton = styled(MuiIconButton)(({ theme }) => ({
  '&:focus-visible': {
    outline: `3px solid ${theme.palette.primary.light}`,
    outlineOffset: 2,
  },
})) as typeof MuiIconButton;
